import { render, staticRenderFns } from "./ClientGoals.vue?vue&type=template&id=1766ed99&"
import script from "./ClientGoals.vue?vue&type=script&lang=js&"
export * from "./ClientGoals.vue?vue&type=script&lang=js&"
import style0 from "./ClientGoals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports